import { styled } from '@mui/system';
import { Box } from '@mui/material';

type ContainerProps = {
    backgroundColor?: string;
};

export const Container = styled(Box)<ContainerProps>(({ backgroundColor }) => ({
    backgroundColor: backgroundColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    padding: '4px 12px',
    borderRadius: '40px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    minWidth: '120px',
    width: 'fit-content',
    boxSizing: 'border-box'
}));

type TextProps = {
    color?: string;
};

export const Text = styled('span')<TextProps>(({ color }) => ({
    color: color,
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    whiteSpace: 'nowrap'
}));
